/**
 * LoadingSpinner - Componente de loading reutilizable
 * Muestra un spinner circular con mensaje opcional
 */
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * @component LoadingSpinner
 * @description Spinner de carga centrado con mensaje opcional
 * @param {Object} props
 * @param {string} [props.size='medium'] - Tamaño del spinner: small, medium, large
 * @param {boolean} [props.fullScreen=false] - Si ocupa toda la pantalla
 * @param {string} [props.message] - Mensaje opcional a mostrar
 */
const LoadingSpinner = ({ size = 'medium', fullScreen = false, message }) => {
  const sizeMap = {
    small: 30,
    medium: 50,
    large: 70,
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        ...(fullScreen && {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
        }),
        ...(!fullScreen && {
          minHeight: 200,
          width: '100%',
        }),
      }}
    >
      <CircularProgress size={spinnerSize} />
      {message && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  fullScreen: PropTypes.bool,
  message: PropTypes.string,
};

export default LoadingSpinner;
